import { SagaIterator } from 'redux-saga';
import { sentryCatch } from 'src/modules/config/utils/sentryCatch';
import { showNotification } from 'src/modules/notifications/sagas/showNotification';
import { PROJECT_LIST_SET_COLUMNS } from 'src/modules/project-list/actions/ProjectListActions';
import { saveProjectListColumns } from 'src/modules/project-list/sagas/utils/saveProjectListColumns';
import { logDebug, logError } from 'src/sagas/utils/logging';
import { GetTriggerActionType } from 'src/utils/createTrigger';
import { call } from 'typed-redux-saga';

export function* projectListSetColumnsSaga(
  action: GetTriggerActionType<typeof PROJECT_LIST_SET_COLUMNS>,
): SagaIterator<void> {
  const columns = action.data;

  try {
    yield* call(logDebug, 'Settings project list columns...', columns);
    yield* call(saveProjectListColumns, columns);
    yield* call(logDebug, 'Settings project list columns... done', columns);
  } catch (error) {
    yield* call(sentryCatch, error);
    yield* call(showNotification, { variant: 'error', type: 'error' });

    yield* call(logError, 'Settings project list columns... error', error);
  }
}
